module.exports = __webpack_public_path__ + "img/aussermittige_einzellast.6306023d.png";